import React from "react";
import css from "./LinkView.module.css";
import {link0} from "Assets";


export default function LinkView(props){
    const {url,alt}=props;
    return (
        <a 
            className={`button ${css.linkview} ${props.className||""}`}
            href={url}
            target="_blank"
        >
            <img alt="opens a new tab" className={css.icon} src={link0(textColor)}/>
            <span className={css.label}>{props.label}</span>
        </a>
    )
}
